import _to from './to';
import _from from './from';

export class Map {
  static from = _from;
  static to   = _to;
}

export type { Types } from './types';